import {Badge} from "react-bootstrap"
import classes from "./css/msisdnUtils.module.css"
import Dropdown from 'react-bootstrap/Dropdown';
import {STATUS_ACTIVE, STATUS_NOT_ACTIVE, STATUS_ONBOARDING, STATUS_DEACTIVATED} from "../Constants";

export function getBadgeForStatus(status)
    {
        if(status === "ACTIVE")
        {
            return (
                <Badge className={classes.badge} bg="success" size={40}>Active</Badge>
            )
        }
        else if(status === "ONBOARDING")
        {
            return (
                <Badge className={classes.badge} bg="warning" size={40}>On-boarding</Badge>
            )
        }
        else
        {
            return (
                <Badge className={classes.badge} bg="secondary" size={40}>Not-Active</Badge>
            )
        }
}

export function getStatusDropdown(currentStatus, onStatusSelected, t)
{
    return (
        <Dropdown className="w-100">
            <Dropdown.Toggle variant={colorForStatus(currentStatus)} id="dropdown-basic" className="w-100">
                {statusToString(currentStatus, t)}
            </Dropdown.Toggle>
    
            <Dropdown.Menu>
                <Dropdown.Item onClick={() => {onStatusSelected(STATUS_ACTIVE)}}>{statusToString(STATUS_ACTIVE, t)}</Dropdown.Item>
                <Dropdown.Item onClick={() => {onStatusSelected(STATUS_ONBOARDING)}}>Onboarding</Dropdown.Item>
                <Dropdown.Item onClick={() => {onStatusSelected(STATUS_NOT_ACTIVE)}}>Not-Active</Dropdown.Item>
            </Dropdown.Menu>
        </Dropdown>
    )
}

export function statusToString(status, t)
{
    if (status === STATUS_DEACTIVATED){
        return t("pages.workers.registerNewWorkerDialog.deactivated");
    }
    else if(status === STATUS_ACTIVE)
    {
        return t("pages.workers.status.active");
    }
    else if(status === STATUS_ONBOARDING)
    {
        return t("pages.workers.status.onboarding")
    }
    else if(status === STATUS_NOT_ACTIVE)
    {
        return t("pages.workers.status.inactive")
    }
    else 
    {
        return t("pages.workers.status.unknown")
    }
}

export function colorForStatus(status)
{
    if(status === STATUS_ACTIVE)
    {
        return "success";
    }
    else if(status === STATUS_ONBOARDING)
    {
        return "warning"
    }
    else 
    {
        return "secondary"
    }
}

export function stringToHslColor(str, saturation = 65, lightness = 55) {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  const hue = Math.abs(hash) % 360;
  return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
}
